import { ValidOpenstackResource } from "../../../../types";

const useCheckFormChanged = (
  formData: { [key: string]: any },
  network?: ValidOpenstackResource,
) => {
  return (
    formData.name !== network?.name ||
    Number(formData.mtu) !== network?.mtu ||
    Boolean(formData.portSecurity) !== network?.port_security_enabled
  );
};

export default useCheckFormChanged;
